var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cfdis-related-replacement box" },
    [
      _c(
        "div",
        { staticClass: "is-pulled-right" },
        [
          !_vm.disabled
            ? _c(
                "BButton",
                {
                  staticClass: "button-search-documents",
                  attrs: {
                    type: "is-primary",
                    "icon-left": "magnify",
                    outlined: "",
                    disabled: !_vm.customer
                  },
                  on: {
                    click: function($event) {
                      return _vm.openModal("CfdisRelated")
                    }
                  }
                },
                [_vm._v("\n      Buscar documentos\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "p",
        { staticClass: "title is-4 has-text-primary title-return-uuids" },
        [_vm._v("\n    CFDI Relacionados\n  ")]
      ),
      _vm._l(_vm.uuidsRelated, function(relationType) {
        return _c(
          "div",
          { key: relationType.key, staticClass: "field" },
          [
            _c("label", { staticClass: "label" }, [
              _vm._v(
                " " +
                  _vm._s(relationType.key) +
                  " - " +
                  _vm._s(relationType.value)
              )
            ]),
            _c("BTaginput", {
              attrs: { icon: "label", disabled: _vm.disabled },
              on: {
                add: function($event) {
                  return _vm.onInput($event, relationType.key)
                },
                remove: _vm.onDelete
              },
              model: {
                value: relationType.uuids,
                callback: function($$v) {
                  _vm.$set(relationType, "uuids", $$v)
                },
                expression: "relationType.uuids"
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }